import { render, staticRenderFns } from "./lockpage.vue?vue&type=template&id=0f9d4814&scoped=true&"
import script from "./lockpage.vue?vue&type=script&lang=js&"
export * from "./lockpage.vue?vue&type=script&lang=js&"
import style0 from "./lockpage.vue?vue&type=style&index=0&id=0f9d4814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d4814",
  null
  
)

export default component.exports